import { LABELS } from "common/labels";
import UiDialog from "components/Custom/UiDialog";
import React from "react";

const AreaVehiclesInfo = (props: any) => {
  const { polygonVehicles, polygonInfo, setPolygonInfo } = props;

  return (
    <>
      {polygonInfo.id && (
        <UiDialog
          title={LABELS.LOCATION + " : " + polygonInfo.areaName}
          open={true}
          size={"xs"}
          onClose={() => {
            setPolygonInfo({});
          }}
        >
          <div>
            <h3
              style={{
                color: "blue",
                margin: "-15px",
                padding: " 0 15px 10px",
              }}
            >
              <label>{LABELS.VEHICLES_LIST}</label>
            </h3>

            <hr></hr>
            <table>
              <thead style={{ position: "sticky" }}>
                <tr>
                  <th>Sl N0</th>
                  <th>Vehicle No</th>
                </tr>
              </thead>
              <tbody>
                {polygonVehicles.map((vehicle, index) => {
                  return (
                    <tr key={"polygonVehicle" + index}>
                      <td>{index + 1}</td>
                      <td>{vehicle.name}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </UiDialog>
      )}
    </>
  );
};

export default AreaVehiclesInfo;
